import { useMemo } from 'react';
import type React from 'react';

import type { Paths } from '@zg-rentals/paths-manifest';

import { RMWContext } from '../RMWContext';

type Props = {
  brand: string;
  isInMobileWebView: boolean;
  paths: Paths;
  children: React.ReactNode;
};

const RMWProvider = ({ brand, isInMobileWebView, paths, children }: Props) => {
  const contextValue = useMemo(() => ({ brand, isInMobileWebView, paths }), [brand, isInMobileWebView, paths]);

  return <RMWContext.Provider value={contextValue}>{children}</RMWContext.Provider>;
};

export default RMWProvider;
